var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#0E5FF5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.15-240q-100.23 0-170.19-69.81Q240-379.63 240-479.85q0-100.23 69.81-170.19Q379.63-720 479.85-720q100.23 0 170.19 69.81Q720-580.37 720-480.15q0 100.23-69.81 170.19Q580.37-240 480.15-240Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadIcon);
export default __webpack_public_path__ + "static/media/unread_icon.ddc53b377f7b5927785134c91db27ae8.svg";
export { ForwardRef as ReactComponent };